import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
    gap: 2rem;
`;

export const Title = styled.h1`
    color: ${Colors.secondary[100]};
    font-size: 5rem;
    font-weight: bold;
    margin: 0;
`;

export const FinishButton = styled.button`
    margin-top: 1rem;
    width: 18rem;
    height: 6rem;
    border: none;
    background-color: ${Colors.primary[100]};
    border: 2px solid ${Colors.stripes.darkBlue};
    color: ${Colors.commons.white};
    font-size: 1.75rem;
    border-radius: 1rem;
    box-shadow: 1rem 1rem 1rem ${Colors.commons.black}4D;
    cursor: pointer;
`;
